function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 15.745h8.142L7.645 18.29l1.06 1.061L13 14.995l-4.292-4.353-1.061 1.061 2.495 2.542H2v1.5zM22 9.728h-8.142l2.497 2.544-1.061 1.06L11 8.979l4.292-4.353 1.06 1.06-2.494 2.543H22v1.5z",
  fill: "#111"
});

function SvgCompareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgCompareIcon;